// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CommentOutlinedSvg from "@ant-design/icons-svg/es/asn/CommentOutlined";
import AntdIcon from '../components/AntdIcon';

var CommentOutlined = function CommentOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CommentOutlinedSvg
  }));
};

CommentOutlined.displayName = 'CommentOutlined';
export default React.forwardRef(CommentOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CommentOutlined.js
// module id = 839
// module chunks = 0